import Routing from "./routes";

const App = () => {
  return (
    <div className="w-full flex flex-col items-center justify-center overflow-x-hidden overflow-y-auto">
      <Routing />
    </div>
  );
};

export default App;
